import { useEffect, useState } from 'react';

export enum SapphireMediaSize {
  ExtraSmall = 'ExtraSmall',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  ExtraLarge = 'ExtraLarge',
}

function getMediaHookData() {
  const size = getMediaSize(window.innerWidth);

  return {
    media: size,
    isExtraSmall: size === SapphireMediaSize.ExtraSmall,
    isSmall: size === SapphireMediaSize.Small,
    isMedium: size === SapphireMediaSize.Medium,
    isLarge: size === SapphireMediaSize.Large,
    isExtraLarge: size === SapphireMediaSize.ExtraLarge,
  };
}

export const BREAKPOINTS = {
  xs: 576,
  sm: 768,
  md: 960,
  lg: 1200,
  xl: 1400,
};

function getMediaSize(windowSize: number) {
  if (windowSize < BREAKPOINTS.xs) {
    return SapphireMediaSize.ExtraSmall;
  }

  if (windowSize < BREAKPOINTS.sm) {
    return SapphireMediaSize.Small;
  }

  if (windowSize < BREAKPOINTS.md) {
    return SapphireMediaSize.Medium;
  }

  if (windowSize < BREAKPOINTS.xl) {
    return SapphireMediaSize.Large;
  }

  return SapphireMediaSize.ExtraLarge;
}

export function useSapphireMedia() {
  function handleResize() {
    setMedia(getMediaHookData());
  }

  const [media, setMedia] = useState(getMediaHookData());
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return media;
}
